// @flow

import React from 'react';
import type { Node } from 'react';

import { subscribeFieldDescriptionCls } from 'shared_components/common/subscription/Description.less';

type Props = { formatMessage: Function };

/**
 * SubscriptionFieldDescription
 *
 * @param {Props} props
 * @returns {Node}
 */
export const SubscriptionFieldDescription = ({ formatMessage }: Props): Node => (
  <div className={subscribeFieldDescriptionCls}>
    <strong>{formatMessage({ id: 'forms.common.confirmSubscribeTitle' })}</strong>
    {formatMessage({ id: 'forms.common.confirmSubscribeText' })}
  </div>
);
